import { paths } from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'
import { Button } from 'mmfintech-portal-commons'
import { useHistory } from 'react-router-dom'
import './AccessDenied.scss'

function AccessDenied() {
  const history = useHistory()

  return (
    <div className='access-denied'>
      <div className='text-container'>
        <h1 className='title'>{tr('PORTAL.COMPONENTS.ACCESS_DENIED.TITLE', 'Access denied')}</h1>
        {tr(
          'PORTAL.COMPONENTS.ACCESS_DENIED.CONTENT',
          'Sorry but it seems that you cannot access this area because your account does not have the right to view this page.'
        )}
        <Button
          type='button'
          color='alternative'
          className='button-back'
          text={tr('PORTAL.COMPONENTS.ACCESS_DENIED.BACK_BUTTON', 'Back to Overview')}
          onClick={() => history.push(paths.dashboard())}
          data-test='button-back'
        />
      </div>
    </div>
  )
}

export default AccessDenied
